import { render, staticRenderFns } from "./FlowTypes.vue?vue&type=template&id=b50a4d0a&"
import script from "./FlowTypes.vue?vue&type=script&lang=js&"
export * from "./FlowTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports